import React, { FC } from 'react';
import { createFragmentContainer, graphql } from 'react-relay';
import { GridCol } from 'dibs-elements/exports/Grid';
import HpRespModuleItemTile from '../HpRespModuleItemTile/HpRespModuleItemTile';
import { slugify } from '../../utils/slugify';

import styles from './HpRespShopByModuleItem.scss';

import { HpRespShopByModuleItem_item } from './__generated__/HpRespShopByModuleItem_item.graphql';

type Props = {
    item: HpRespShopByModuleItem_item;
    onClick: () => void;
    useLazyLoadImages: boolean;
};

export const HpRespShopByModuleItem: FC<Props> = ({
    item,
    onClick = () => {},
    useLazyLoadImages,
}) => {
    const { linkData, title, description, imageUrl, imageHeight, imageWidth, cta } = item;
    return (
        <GridCol mobile={6} tabletLandscape={3}>
            <div className={styles.item}>
                <HpRespModuleItemTile
                    linkData={linkData}
                    dataTn={`shopBy-module-item-${slugify(item.title)}`}
                    onClick={onClick}
                    title={title}
                    description={description}
                    cta={cta}
                    imageUrl={imageUrl}
                    imgSrcSetWidths={[230, 360, 500, 760]}
                    imgSizes="(max-width:768px) 50vw, (max-width:1024px) 230px, 360px"
                    imageHeight={imageHeight}
                    imageWidth={imageWidth}
                    useLazyLoadImages={useLazyLoadImages}
                />
            </div>
        </GridCol>
    );
};

export default createFragmentContainer(HpRespShopByModuleItem, {
    item: graphql`
        fragment HpRespShopByModuleItem_item on Product {
            title
            description
            cta
            imageUrl
            imageHeight
            imageWidth
            linkData {
                ...HpRespModuleItemTile_linkData
            }
        }
    `,
});
